module.exports = __webpack_public_path__ + "img/65.5c91aabe.jpg";